import { PreviewThumb } from '@/components/PreviewThumb';
import { useSeriesLabel } from '../../hooks/useStudyThumbnail';
import { useObjectUrl } from '../../hooks/useObjectUrl';

/**
 * The slide's label (the scanner's photo of its sticker) as a small square at
 * the right end of the panel's tab strip, for the image on screen, whichever
 * tab is open. Hovering — or tapping, where nothing hovers — shows it large
 * enough to read. Nothing is drawn until there is one: most converted scanner
 * files have none, and the strip is no place for a placeholder.
 */
export function LabelImage({ studyInstanceUID, seriesInstanceUID }: { studyInstanceUID: string | undefined; seriesInstanceUID: string | undefined }) {
  const { data } = useSeriesLabel(studyInstanceUID, seriesInstanceUID);
  const url = useObjectUrl(data?.bytes);
  if (!data || !url) return null;
  return <PreviewThumb url={url} aspect={data.aspect} alt="Slide label" toggleOnClick className="h-7 w-7 shrink-0 cursor-zoom-in" />;
}
